import { render, staticRenderFns } from "./NotificationTemplate.vue?vue&type=template&id=758cd000&scoped=true"
import script from "./NotificationTemplate.vue?vue&type=script&lang=js"
export * from "./NotificationTemplate.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplate.vue?vue&type=style&index=0&id=758cd000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758cd000",
  null
  
)

export default component.exports